import { render, staticRenderFns } from "./SupplierDetail.vue?vue&type=template&id=702d871e&scoped=true"
import script from "./SupplierDetail.vue?vue&type=script&lang=ts"
export * from "./SupplierDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702d871e",
  null
  
)

export default component.exports